import script from "./CardElement.vue?vue&type=script&setup=true&lang=js"
export * from "./CardElement.vue?vue&type=script&setup=true&lang=js"

import "./CardElement.vue?vue&type=style&index=0&id=33296fb4&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33296fb4"]])

export default __exports__